import React from 'react';
import '../../styles/sections.css';
import '../../styles/technologies.css';

const Technologies = () => (
  <div className="technologies-section">
    <div className="section-header">
      <h2>TECHNOLOGIES</h2>
      <div className="underline"></div>
    </div>
    <div className="technologies-content">
      <h3>Development Platform</h3>
      <ul>
        <li><strong>Roblox Studio:</strong> Primary development environment</li>
        <li><strong>Lua Scripting:</strong> Core programming language</li>
        <li><strong>Roblox Engine:</strong> Game engine and physics system</li>
      </ul>

      <h3>Core Technologies</h3>
      <ul>
        <li><strong>Luau:</strong> Enhanced Lua implementation for Roblox</li>
        <li><strong>Roblox Services:</strong> Built-in game services and APIs</li>
        <li><strong>Remote Events:</strong> Client-server communication</li>
        <li><strong>Data Stores:</strong> Player data persistence</li>
      </ul>

      <h3>Game Systems</h3>
      <ul>
        <li><strong>Physics Engine:</strong> Built-in Roblox physics</li>
        <li><strong>Animation System:</strong> Character and object animations</li>
        <li><strong>UI Framework:</strong> Roblox GUI system</li>
        <li><strong>Networking:</strong> Multiplayer synchronization</li>
      </ul>
    </div>
  </div>
);

export default Technologies;
